import { useMemo, useState } from 'react';
import Proptypes from 'prop-types';
import { Box, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { parseIccids, validateIccidList } from '../../utils/iccid';

const IccidOrganizationListForm = ({ onSubmit, loading, disabled }) => {
  const [text, setText] = useState('');

  const parsed = useMemo(() => parseIccids(text, { splitOnWhitespace: true }), [text]);
  const error = text.trim() ? validateIccidList(parsed) : null;

  return (
    <Box paddingTop={4}>
      <TextField
        fullWidth
        label="ICCIDs — one per line, or separated by comma / semicolon"
        multiline
        rows={6}
        value={text}
        onChange={(e) => setText(e.target.value)}
        error={!!error}
        helperText={error || (parsed.iccids.length ? `${parsed.iccids.length} distinct ICCIDs` : ' ')}
      />

      <LoadingButton
        loading={loading}
        disabled={disabled || loading || !parsed.iccids.length || !!error}
        onClick={() => onSubmit('bulk', { iccids: parsed.iccids })}
        sx={{ my: 2 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

IccidOrganizationListForm.propTypes = {
  onSubmit: Proptypes.func,
  loading: Proptypes.bool,
  disabled: Proptypes.bool,
};
export default IccidOrganizationListForm;
